export const CONTACT = {
  email: "support@vetas.in",
  phones: ["9910803462", "9971171951"],
  positioning: "Your one stop solution vendor for everything.",
};

export const IMAGES = {
  heroApparel: "/brand/img/heroApparel.jpg",
  tshirtRack: "/brand/img/tshirtRack.jpg",
  tshirtColored: "/brand/img/tshirtColored.jpg",
  teamMeeting: "/brand/img/teamMeeting.jpg",
  teamGift: "/brand/img/teamGift.jpg",
  meetingTable: "/brand/img/meetingTable.jpg",
  giftRibbon: "/brand/img/giftRibbon.jpg",
  giftBox: "/brand/img/giftBox.jpg",
  packagingSet: "/brand/img/packagingSet.jpg",
  giftBrown: "/brand/img/giftBrown.jpg",
  gadgets: "/brand/img/gadgets.jpg",
  gadgets2: "/brand/img/gadgets2.jpg",
  techDesk: "/brand/img/techDesk.jpg",
  whiteHeadphones: "/brand/img/whiteHeadphones.jpg",
  handshake: "/brand/img/handshake.jpg",
  handshake2: "/brand/img/handshake2.jpg",
  eventStage: "/brand/img/eventStage.jpg",
  eventAudience: "/brand/img/eventAudience.jpg",
  networking: "/brand/img/networking.jpg",
  networking2: "/brand/img/networking2.jpg",
  office: "/brand/img/office.jpg",
  sustain1: "/brand/img/sustain1.jpg",
  sustain2: "/brand/img/sustain2.jpg",
  ngo1: "/brand/img/ngo1.jpg",
  ngo2: "/brand/img/ngo2.jpg",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Corporate Clients" },
  { value: 100, suffix: "+", label: "Brand Associations" },
  { value: 400, suffix: "+", label: "Voucher Brands" },
  { value: 25, suffix: "+", label: "States Covered" },
];

export const WHY = [
  { n: "01", title: "One-Stop Solution", body: "Multiple corporate requirements handled through a single partner and one relationship." },
  { n: "02", title: "Wide Brand Network", body: "Access to a large network of brands and manufacturers across categories." },
  { n: "03", title: "Customization", body: "Solutions tailored to your requirement, brand identity and internal culture." },
  { n: "04", title: "Quality & Delivery", body: "Sourcing and in-house manufacturing built to support quality and timely delivery." },
  { n: "05", title: "Pan-India Reach", body: "Corporate requirements fulfilled across 25+ states, delivered nationwide." },
];

export const SOLUTIONS = [
  { n: "01", title: "Corporate Merchandise", desc: "Branded apparel, uniforms and team merchandise, produced in-house.", img: IMAGES.tshirtColored },
  { n: "02", title: "Employee & Corporate Gifting", desc: "Joining kits, festive gifting and premium curated hampers.", img: IMAGES.giftRibbon },
  { n: "03", title: "Channel Partner Engagement", desc: "Reward and engagement programs for retailer & distributor networks.", img: IMAGES.handshake },
  { n: "04", title: "Events & Activations", desc: "Event kits and promotional merchandise for corporate moments.", img: IMAGES.eventStage },
  { n: "05", title: "Rewards & Gift Cards", desc: "Vouchers across 400+ brands and every reward category.", img: IMAGES.whiteHeadphones },
  { n: "06", title: "Sustainable Solutions", desc: "Recycled-plastic apparel and conscious corporate merchandise.", img: IMAGES.sustain1 },
  { n: "07", title: "Gadgets & Electronics", desc: "Power banks, smartwatches, audio and white goods.", img: IMAGES.gadgets },
];

export const PRODUCTS = [
  { tag: "WEAR", title: "Apparel & Uniforms", items: "T-shirts · Polos · Hoodies · Jackets · Caps · Uniforms", img: IMAGES.tshirtRack },
  { tag: "GIFT", title: "Gifting & Kits", items: "Corporate gifts · Festive gifting · Joining kits · Partner gifts", img: IMAGES.packagingSet },
  { tag: "TECH", title: "Gadgets & Electronics", items: "Power banks · Smartwatches · Headphones · Speakers · Alexa", img: IMAGES.gadgets2 },
  { tag: "REWARD", title: "Vouchers & Gift Cards", items: "Food · Shopping · Entertainment · Travel · 400+ brands", img: IMAGES.giftBox },
  { tag: "SUSTAIN", title: "Sustainable Range", items: "Recycled plastic apparel · Conscious merchandise", img: IMAGES.sustain2 },
];

export const CLIENTS = [
  { name: "Pepsi", logo: "/brand/clients/pepsi.png" },
  { name: "Asian Paints", logo: "/brand/clients/asianpaints.png" },
  { name: "Hyundai", logo: "/brand/clients/hyundai.png" },
  { name: "Kellogg's", logo: "/brand/clients/kelloggs.png" },
  { name: "L'Oréal", logo: "/brand/clients/loreal.png" },
  { name: "Radisson Hotel Group", logo: "/brand/clients/radisson.png" },
  { name: "Gatorade", logo: "/brand/clients/gatorade.png" },
  { name: "Mountain Dew", logo: "/brand/clients/mountaindew.png" },
  { name: "GMR", logo: "/brand/clients/gmr.png" },
  { name: "7UP", logo: "/brand/clients/7up.png" },
  { name: "Slice", logo: "/brand/clients/slice.png" },
  { name: "TNPCB", logo: "/brand/clients/tnpcb.png" },
  { name: "Umaid Bhawan Palace", logo: "/brand/clients/umaid.png" },
  { name: "Shree Cement", logo: "/brand/clients/shreecement.png" },
  { name: "Dabur", logo: "/brand/clients/dabur.png" },
  { name: "Sting", logo: "/brand/clients/sting.png" },
  { name: "Mirinda", logo: "/brand/clients/mirinda.png" },
];

// Placeholder testimonials — to be replaced with verified client quotes.
export const TESTIMONIALS = [
  { quote: "One partner handled our apparel, gifting and rewards end to end — it removed the coordination overhead we used to have with multiple vendors.", author: "Procurement Lead", role: "Leading FMCG Brand" },
  { quote: "From onboarding kits to festive gifting, everything arrived on time and on-brand across our locations.", author: "HR & Admin Head", role: "Hospitality Group" },
  { quote: "Their brand network gave us the flexibility to build a reward program our channel partners actually value.", author: "Sales Head", role: "Consumer Brand" },
];

export const BRANDS = [
  "Apple", "Samsung", "boAt", "JBL", "Noise", "OnePlus", "Lenovo", "Philips",
  "Bajaj", "Usha", "Häfele", "V-Guard", "Cello", "Borosil", "Portronics",
  "Samsonite", "American Tourister", "VIP", "Skechers", "Asics", "Jack & Jones",
  "Allen Solly", "U.S. Polo Assn.", "Titan", "Ray-Ban", "Levi's", "Adidas",
  "Puma", "Tommy Hilfiger", "Lacoste", "Bose", "Dell", "HP", "LG", "Dyson",
  "Godrej", "Ambrane", "Marshall", "Beardo", "Tanishq", "Skybags", "Mokobara",
];

export const VOUCHER_CATS = [
  "Food & Beverage", "Sports & Athleisure", "Entertainment & OTT", "Apparel & Accessories",
  "Grocery & Home Care", "Ecommerce & Online", "Mobile & Electronics", "Flights & Hotels",
  "Fashion & Beauty", "Cabs & Travel", "Automobiles", "Spa & Wellness",
];

export const REQUIREMENT_TYPES = [
  "Corporate Merchandise", "Employee Joining Kits", "Corporate Gifting",
  "Channel Partner Engagement", "Event Kits", "Gadgets & Electronics",
  "Vouchers & Gift Cards", "Sustainable Products", "Other",
];

export const WORK = [
  {
    client: "FMCG Leader", cat: "Corporate Merchandise", img: IMAGES.tshirtColored,
    requirement: "A nationwide field team needed consistent, on-brand uniforms delivered across multiple states before a product launch.",
    solution: "In-house manufactured polo t-shirts and caps with embroidered branding, size-graded and kitted by region.",
    scale: "Multi-state rollout", outcome: "A single coordinated production and delivery cycle replaced multiple local vendors.",
  },
  {
    client: "Hospitality Group", cat: "Corporate Gifting", img: IMAGES.giftRibbon,
    requirement: "Premium festive gifting for guests and partners across several properties, with a consistent luxury feel.",
    solution: "Curated festive hampers with custom packaging and property-level personalization, sourced from our brand network.",
    scale: "Multi-property", outcome: "One gifting partner managed sourcing, packaging and dispatch end to end.",
  },
  {
    client: "Consumer Brand", cat: "Channel Partner Engagement", img: IMAGES.handshake2,
    requirement: "A reward program to engage and retain retailer and distributor networks throughout the year.",
    solution: "Tiered reward catalogue combining gadgets, vouchers and branded merchandise, fulfilled on demand.",
    scale: "Pan-India network", outcome: "Partners redeemed rewards from a single managed catalogue.",
  },
  {
    client: "Enterprise", cat: "Employee Joining Kits", img: IMAGES.teamGift,
    requirement: "A polished onboarding experience for new employees joining across locations.",
    solution: "Branded joining kits pairing apparel, tech accessories and welcome collateral in custom packaging.",
    scale: "Ongoing", outcome: "New hires received a consistent, ready-to-ship welcome kit.",
  },
];

export const INSIGHTS = [
  { cat: "Gifting", title: "Designing corporate gifting that people actually keep", read: "5 min" },
  { cat: "Engagement", title: "Building channel-partner programs that drive loyalty", read: "6 min" },
  { cat: "Sustainability", title: "Why recycled-plastic apparel is the future of merch", read: "4 min" },
];
